import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { useMediaQuery } from "react-responsive";
import { jsPDF } from "jspdf";
import printJS from "print-js";
import { useHistory } from "react-router-dom";

//redux
import { useDispatch, useSelector } from "react-redux";

// styles
import styles from "./OrdersPage.module.scss";

// config
import GLOBAL_MEDIA_QUERIES from "../../../config/globalMediaQueries";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import {
  notifyError,
  notifyPendingIncomingOrders,
  notifyServerError,
} from "../../../config/toastNotification";

// icons
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import blxLogo from "../../../assets/images/logo.jpeg";

//interfaces
import {
  IOrderStatus,
  IPartnerOrder,
  IPartnerOrderRequestModel,
} from "../../../interfaces/order";

//api
import apis from "../../../api/apis";
import {
  orderListRequestModel,
  statusForBtnsRequestModel,
  baseRequestModel as statusForTabsRequestModel,
  orderRequestModel,
} from "../../../api/apiRequestObjects";

// components
import OrderCount from "../orderCount/OrderCount";
import DataTable from "../dataTable/DataTable";
import SearchBox from "./components/searchBox/SearchBox";
import OrderDetails from "../orderDetails/OrderDetails";
import BasicModal from "../../basicModal/BasicModal";
import FilterBox from "./components/filterBox/FilterBox";
import LoadingComponent from "../../loadingComponent/LoadingComponent";
import orderStatus from "../../../config/orderStatus";
import moment from "moment";
import { Button, Chip, Stack } from "@mui/material";
import SnackBar, { SnackBarModel } from "../../snackBar/SnackBar";
import { API_INTEGRATION_ID } from "../../../config";
import axios from "axios";
import { IBaseModel } from "../../../interfaces/base";
import { IPartnerStore } from "../../../interfaces/store";
import { IStorePartner } from "../../../interfaces/configuration";
/* import { IBaseModel } from "../../../interfaces/base";
import { API_INTEGRATION_ID } from "../../../config";
import { getStatus } from "../../redux/actions/store/status"; */

const OrdersPage = (): JSX.Element => {
  const isTablet = useMediaQuery({ query: GLOBAL_MEDIA_QUERIES.tab });

  const [orderList, setOrderList] = useState<IPartnerOrder[]>([]);
  const [navItems] = useState<IOrderStatus[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(orderList[0]);
  const [selectedNavItem, setSelectedNavItem] = useState<IOrderStatus>(
    navItems[0]
  );
  //console.log(selectedItem);
  //console.log(selectedNavItem);
  const [statusForBtn, setStatusForBtn] = useState<IOrderStatus[]>([]);
  const [incomingOrderCount, setIncomingOrderCount] = useState(0);
  const [isIncomingOrderArrive, setIsIncomingOrderArrive] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  /*  const [opacityValue, setOpacityValue] = useState(1); */
  const componentMounted = useRef(true);
  //const prevSelectedNavItemRef = useRef<IOrderStatus>();

  /*   const dispatch = useDispatch();
  const { loading, status } = useSelector(
    (state: any) => state.getStoreStatusReducer
  ); */
  //get redux state
  const { user } = useSelector((state: any) => state.authentication);
  //console.log("userN", user);
  const history = useHistory();

  //fetch OrderList
  useEffect(() => {
    //     const data:IBaseModel={
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: '',
    //     ApplicationId: '',
    //     LocationApiKey: '',
    //     RequestingUser: 0,
    //     RequestingId: '',
    //     Schema: '',
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0
    //   }

    // dispatch(getStatus(data))

    const fetchOrderListData = async () => {
      try {
        setIsLoading(true);

        orderListRequestModel.UID.UserKey = user.UserKey;
        orderListRequestModel.UID.LocationKey = user.LocationKey;
        orderListRequestModel.UID.CompanyKey = user.CompanyKey;
        orderListRequestModel.UID.EnvironmentName = user.EnvironmentName;
        //console.log(orderListRequestModel);
        //if (selectedNavItem)
        orderListRequestModel.POSStatusKey = selectedNavItem
          ? selectedNavItem.POSStatusKey
          : orderStatus.all;
        orderListRequestModel.OrderDate = filteredDateValue ?? moment();
        orderListRequestModel.PageNo = 1;

        const response = await apis.Orders.fetchPartnerOrderList(
          orderListRequestModel
        );

        if (response.ResponseType === APIResponseType.Success) {
          response.ResponseData.AllOrders.forEach((order) => {
            let x = orderList.find(
              (e) => e.PartnerOrderId === order.PartnerOrderId
            );

            if (x === undefined) {
              orderList.push(order);
              //orderList.sort((a, b) => (a.OrderDate > b.OrderDate ? 1 : -1));
            }
          });
          //console.log("ordelist", orderList);
          setSelectedItem(orderList[0]);

          setIsLoading(false);
        } else {
          //notifyError();
          //setIsLoading(false);
          //console.log("api fetching error");
        }
      } catch (e) {
        //setIsLoading(false);
        notifyServerError();
        //console.log(e);
      }
    };

    fetchOrderListData();
  }, [selectedNavItem]);

  //fetch OrderStatus for Tabs
  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        setIsLoading(true);
        statusForTabsRequestModel.UID.UserKey = user.UserKey;
        statusForTabsRequestModel.UID.LocationKey = user.LocationKey;
        statusForTabsRequestModel.UID.CompanyKey = user.CompanyKey;
        statusForTabsRequestModel.UID.EnvironmentName = user.EnvironmentName;

        const response = await apis.Orders.fetchOrderStatus(
          statusForTabsRequestModel
        );

        if (response.ResponseType === APIResponseType.Success) {
          response.ResponseData.OrderStatusList.sort((a, b) =>
            a.SortingOrder > b.SortingOrder ? 1 : -1
          ).forEach((orderStatus) => {
            navItems.find(
              (e) => e.POSStatusKey === orderStatus.POSStatusKey
            ) === undefined && navItems.push(orderStatus);
          });
          setSelectedNavItem(navItems[0]);

          setIsLoading(false);
        } else {
          //notifyError();
          //setIsLoading(false);
          //console.log("api fetching error");
        }
      } catch (e) {
        //notifyServerError();
        //setIsLoading(false);
        //console.log(e);
      }
    };

    fetchStatusData();
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false;
    };
  }, []);

  //fetch Order Status for Button
  useEffect(() => {
    const fetchOrderStatusBtnData = async () => {
      try {
        statusForBtnsRequestModel.UID.UserKey = user.UserKey;
        statusForBtnsRequestModel.UID.LocationKey = user.LocationKey;
        statusForBtnsRequestModel.UID.CompanyKey = user.CompanyKey;
        statusForBtnsRequestModel.UID.EnvironmentName = user.EnvironmentName;

        statusForBtnsRequestModel.POSStatusKey = selectedNavItem.POSStatusKey;

        if (statusForBtnsRequestModel.POSStatusKey > 0) {
          const response = await apis.Orders.fetchOrderStatusForBtn(
            statusForBtnsRequestModel
          );
          if (response.ResponseType === APIResponseType.Success) {
            //console.log(response.ResponseData.OrderStatusList);
            setStatusForBtn(response.ResponseData.OrderStatusList);
          } else {
            //notifyError();
            //setIsLoading(false);
            //console.log("api fetching error");
          }
        }
      } catch (e) {
        //notifyServerError();
        //setIsLoading(false);
        //console.log(e);
      }
    };

    fetchOrderStatusBtnData();
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false;
    };
  }, [selectedNavItem]);

  // order details modal
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);

  // search modal
  const [searchValue, setSearchValue] = useState("");
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const toggleSearchModal = () => setIsOpenSearch(!isOpenSearch);

  // filter modal
  const [filteredDateValue, setFilteredDateValue] = React.useState<Date | null>(
    new Date()
  );
  const [isFiltered, setIsFilterd] = useState(false);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [partnerList, setPartnerList] = useState<IStorePartner[]>([]);
  //console.log(partnerList);
  const toggleFilterModal = () => setIsOpenFilter(!isOpenFilter);

  //set selected order
  const selectItem = (order: IPartnerOrder) => {
    setSelectedItem(order);

    if (isTablet) {
      toggleModal();
    }
  };

  //snack bar model
  const [snackBarmodel, setSnackBarModel] = useState<SnackBarModel>({
    openSnackBar: false,
    msg: "",
    autoHideDuration: 6000,
  });

  // set Orders Count
  /*   const setCount = (
    oderPosStatus: IOrderStatus,
    orderList: IPartnerOrder[]
  ) => {
    let orderCount = 0;
    {
      orderList &&
        orderList.map((order) => {
          if (
            order.OrderDelivery.OrderStatus.POSStatusKey ===
            oderPosStatus.POSStatusKey
          ) {
            orderCount++;
          }
        });
    }

    return orderCount;
  }; */

  //update Order status in list
  const updateOrder = (
    updatedOrderStatus: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => {
    orderList.forEach((order) => {
      if (order.PartnerOrderId === selectedOrder.PartnerOrderId) {
        order.OrderDelivery.OrderStatus.POSStatusKey =
          updatedOrderStatus.POSStatusKey;
        order.OrderDelivery.OrderStatus.POSStatusCode =
          updatedOrderStatus.POSStatusCode;
        order.OrderDelivery.OrderStatus.POSStatusName =
          updatedOrderStatus.POSStatusName;
      }
    });
    //setTimeout and setup orderlist ??
    //setOrderList(orderList);
    //setCount(updatedOrderStatus, orderList);
    //window.location.reload();
    // setOrderList([...orderList]);
    history.push("/orders");
    window.location.reload();
  };

  //audio playing in notification
  const soundFile = new Audio(process.env.PUBLIC_URL + "/sound/MILANO.mp3");

  //audio event listeners
  soundFile.addEventListener(
    "ended",
    function () {
      this.currentTime = 0;
      if (isIncomingOrderArrive) {
        this.play();
      }
      //this.play();
    },
    false
  );

  //handle play audio
  const handlePlayAudio = () => {
    soundFile.loop = true;
    if (!isAudioPlaying) {
      setIsAudioPlaying(true);
      const playPromise = soundFile.play();
      if (playPromise !== undefined) {
        playPromise
          .then(function () {
            // Automatic playback started!
            //console.log("play ok");
          })
          .catch(function (error) {
            // Automatic playback failed.
            // Show a UI element to let the user manually start playback.
            //console.log("play notOk", error);
          });
        //setSelectedNavItem(navItems[0]);
      } else {
        //console.log("play undefined");
      }
    }
  };

  //showing desktop notification
  const requestNotificationPermission = (order: any) => {
    Notification.requestPermission().then(() =>
      showNotification(Notification.permission, order)
    );
  };
  const showNotification = (permision: any, order: any) => {
    //  console.log(order);
    if (permision !== "granted") {
      return;
    }
    let notification = new Notification(" New Order: " + order.OrderReference, {
      body:
        "You have a new order for Rs. " +
        order.Amount.toFixed(2) +
        ". \n Reference: " +
        order.OrderReference,
      data: "Reference: " + order.OrderReference,
      icon: blxLogo,
      // renotify: true,
    });
    //handlePlayAudio();
    // console.log(notification);
    //const notificationAudio = new Audio(process.env.PUBLIC_URL + "/sound/MILANO.mp3");
  };

  //set interval for getting order real time
  useEffect(() => {
    setInterval(async () => {
      try {
        //setIsLoading(true);
        orderListRequestModel.UID.UserKey = user.UserKey;
        orderListRequestModel.UID.LocationKey = user.LocationKey;
        orderListRequestModel.UID.CompanyKey = user.CompanyKey;
        orderListRequestModel.UID.EnvironmentName = user.EnvironmentName;

        orderListRequestModel.OrderDate = moment();
        orderListRequestModel.POSStatusKey = orderStatus.all;
        const response = await apis.Orders.fetchPartnerOrderList(
          orderListRequestModel
        );
        if (response.ResponseType === APIResponseType.Success) {
          response.ResponseData.AllOrders.forEach((order) => {
            let x = orderList.find(
              (e) => e.PartnerOrderId === order.PartnerOrderId
            );

            // console.log(
            //   moment(moment.now()).isSameOrAfter(
            //     moment(order.OrderDate).add(10.5, "minutes")
            //   )
            // );

            if (x === undefined) {
              //orderList.push(order);
              // console.log(
              //   moment
              //     .utc(moment.now())
              //     .isSameOrAfter(
              //       moment.utc(moment(order.OrderDate).add(10.5, "minutes"))
              //     )
              // );
              //incoming order timeout check
              if (
                order.OrderDelivery.OrderStatus.POSStatusCode ===
                  navItems[0].POSStatusCode &&
                moment
                  .utc(moment.now())
                  .isSameOrAfter(
                    moment.utc(moment(order.OrderDate).add(10.5, "minutes"))
                  )
              ) {
                setOrderList(
                  orderList.filter(
                    (x) => x.PartnerOrderId !== order.PartnerOrderId
                  )
                );
              } else {
                Object.assign(orderList, order);
                requestNotificationPermission(order);
                //console.log(returnedTarget);
                //console.log("ol", orderList);
                //setOrderList(returnedTarget);
                if (
                  order.OrderDelivery.OrderStatus.POSStatusCode ===
                  navItems[0].POSStatusCode
                ) {
                  //let count = incomingOrderCount;
                  setIncomingOrderCount(incomingOrderCount + 1);

                  if (!isIncomingOrderArrive) {
                    handlePlayAudio();
                    setIsIncomingOrderArrive(true);
                  }
                  //console.log("yep");
                  //console.log(soundFile);
                }
              }
            }
          });
        } else {
          //console.log("api fetching error");
        }
      } catch (e) {
        // console.log(e);
      }
    }, 10000);

    //to check whether there are any pending orders every 2 min
    setInterval(async () => {
      if (!isIncomingOrderArrive && !isAudioPlaying) {
        const pendingOrders = orderList.find(
          (x) =>
            x.OrderDelivery.OrderStatus.POSStatusCode ===
            navItems[0].POSStatusCode
        );
        if (pendingOrders !== undefined && pendingOrders !== null) {
          handlePlayAudio();
          setSnackBarModel({
            openSnackBar: true,
            msg: "There are incoming orders waiting for action !",
            autoHideDuration: 8000,
          });
          //notifyPendingIncomingOrders();
        }
      }
    }, 120000);
  }, []);

  //get partner stolre list
  useEffect(() => {
    getPartnerStoreList();
  }, []);

  //handle incoming order notification screen
  const handleNotificationScreen = () => {
    //console.log("notyScreen", orderList);
    window.location.reload();
    soundFile.pause();
    setIsAudioPlaying(false);
    setIsIncomingOrderArrive(false);
    //setSelectedNavItem(navItems[0]);
    //setOrderList(orderList);
  };

  //for setting dynmic opacity
  /*   useEffect(() => {
    setInterval(() => {
      setOpacityValue(Math.random());
    }, 1000);
  }, []); */

  //filterbyOrderDate
  const handleFiltering = (filteredDateValue: Date | null) => {
    setIsFilterd(true);
    setFilteredDateValue(filteredDateValue);
    const fetchOrderListData = async () => {
      try {
        setIsLoading(true);

        orderListRequestModel.UID.UserKey = user.UserKey;
        orderListRequestModel.UID.LocationKey = user.LocationKey;
        orderListRequestModel.UID.CompanyKey = user.CompanyKey;
        orderListRequestModel.UID.EnvironmentName = user.EnvironmentName;
        //console.log(orderListRequestModel);
        //if (selectedNavItem)
        orderListRequestModel.POSStatusKey = selectedNavItem
          ? selectedNavItem.POSStatusKey
          : orderStatus.all;
        orderListRequestModel.OrderDate = filteredDateValue;
        orderListRequestModel.PageNo = 1;

        const response = await apis.Orders.fetchPartnerOrderList(
          orderListRequestModel
        );
        //console.log(response);
        if (response.ResponseType === APIResponseType.Success) {
          /*           setOrderList(
            response.ResponseData.AllOrders.sort((a, b) =>
              a.OrderDate > b.OrderDate ? 1 : -1
            ).filter(
              (order, i) => order.PartnerOrderId !== orderList[i].PartnerOrderId
            )
          ); */
          setOrderList(
            response.ResponseData.AllOrders.sort((a, b) =>
              a.OrderDate > b.OrderDate ? 1 : -1
            )
          );
          /*           response.ResponseData.AllOrders.forEach((order) => {
            let x = orderList.find(
              (e) => e.PartnerOrderId === order.PartnerOrderId
            );

            if (x === undefined) {
              orderList.push(order);
              //orderList.sort((a, b) => (a.OrderDate > b.OrderDate ? 1 : -1));
            }
          }); */
          //console.log("ordelist", orderList);
          setSelectedItem(orderList[0]);

          setIsLoading(false);
        } else {
          //notifyError();
          setIsLoading(false);
          console.log("api fetching error");
        }
      } catch (e) {
        //setIsLoading(false);
        notifyServerError();
        //console.log(e);
      }
    };

    fetchOrderListData();
    toggleFilterModal();
  };

  //remove Filtering by date
  const removeFiltering = () => {
    setIsFilterd(false);
    setFilteredDateValue(null);
    window.location.reload();
  };

  //method to convert base64string to blob
  const b64toBlob = (base64: string, type = "application/pdf") =>
    fetch(`data:${type};base64,${base64}`).then((res) => res.blob());

  //handle bill printing
  const handleBillPrinting = async (
    partnerOrderId: number | undefined,
    orderReference: string | undefined
  ) => {
    if (partnerOrderId !== undefined) {
      orderRequestModel.UID.UserKey = user.UserKey;
      orderRequestModel.UID.LocationKey = user.LocationKey;
      orderRequestModel.UID.CompanyKey = user.CompanyKey;
      orderRequestModel.UID.EnvironmentName = user.EnvironmentName;

      orderRequestModel.PartnerOrderId = partnerOrderId;

      const response = await apis.Orders.getPrintBill(orderRequestModel);

      /*       var imgData =
        "data:application/pdf;base64," +
        response.ResponseData.PartnerOrder.BillReportSource; */
      /*       var pdfData =
        "data:application/pdf;base64," +
        response.ResponseData.PartnerOrder.BillReportSource; */

      if (response.ResponseType === APIResponseType.Success) {
        if (response.ResponseData.PartnerOrder.BillReportSource !== null) {
          //Build a URL from the file
          const fileURL = URL.createObjectURL(
            await b64toBlob(response.ResponseData.PartnerOrder.BillReportSource)
          );

          //Open the URL on new Window
          //window.open(fileURL);
          printJS(fileURL);
        } else {
          //show error msg
          setSnackBarModel({
            openSnackBar: true,
            msg: "Error: Report Source Not Found !",
            autoHideDuration: 6000,
          });
        }
      } else {
        notifyServerError();
      }

      /*       var doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true
       }); */
      //var doc = new jsPDF({ unit: "px" });
      //const imgProps = doc.getImageProperties(imgData);
      /*       const imgProps = doc.getImageProperties(imgData);
      const docWidth = 303;
      const docHeight = (imgProps.height * docWidth) / imgProps.width; */
      //const docWidth = 303;
      //const docHeight = (imgProps.height * docWidth) / imgProps.width;
      //doc.addImage(imgData, "JPEG", 0, 0, docWidth, docHeight);

      //doc.autoPrint({ variant: "non-conform" });
      //window.open(doc.output("datauristring"));
      //doc.save();
      /*  doc.addPage(pdfData);
      doc.output("datauristring", { filename: orderReference });
      doc.autoPrint(); */
      //doc.output();
      //window.print(pdfData);
    }
  };
  //console.log(isLoading);
  const getPickMeOrders = async () => {
    //

    try {
      setIsLoading(true);
      const pickmeOrderModel: IPartnerOrderRequestModel = {
        PartnerOrderId: 0,
        OrderId: "",
        POSStatusKey: 0,
        OrderDate: undefined,
        OrderTypeKey: 0,
        DenyOrCancelReasonCode: "",
        DenyOrCancelReasonKey: 0,
        CurrentPOSStatusCode: "",
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user.CompanyKey,
          LocationKey: user.LocationKey,
          UserKey: user.UserKey,
          EnvironmentName: user.EnvironmentName,
          IsUrbanPiper: user.IsUrbanPiper,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };

      const response = await apis.Orders.getPickMeOrders(pickmeOrderModel);
      //const responst = await axios.get("")
      console.log(response);
      setIsLoading(false);
    } catch (error) {
      console.log("error");
      console.log(error);
      setIsLoading(false);
    }

    //
  };

  const getPartnerStoreList = async () => {
    try {
      setIsLoading(true);
      const requestModel: IBaseModel = {
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      const response = await apis.configuration.getStorePartners(requestModel);

      setPartnerList(response.ResponseData.Storepartners);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingComponent />;

  if (isIncomingOrderArrive)
    return (
      <body
        className={styles.notification_body}
        onClick={handleNotificationScreen}
      >
        <div className={styles.notification_screen_text}>
          <img
            // src={process.env.PUBLIC_URL + "/PartnerLogos/UberEats.svg"}
            src={blxLogo}
            className={styles.notify_logo}
          />
          {/*           <p>
            New <span style={{ fontSize: "120%" }}>{incomingOrderCount}</span>{" "}
            Incoming Order Arrived
          </p> */}
          <p>New Incoming Order Arrived</p>
          <small className={styles.notification_screen_small_text}>
            Tap Anywhere To Continue...
          </small>
        </div>
        <br />
      </body>
    );

  return (
    <div className={styles.main_wrapper}>
      <iframe
        id="pdf-frame"
        style={{ display: "none" }}
        title="Receipt | KOT"
      />

      <div className={styles.list_of_orders}>
        {isFiltered ? (
          <Stack spacing={0.5}>
            <Chip
              label={
                "Showing Orders Placed At: " +
                moment(filteredDateValue).format("DD-MM-YYYY")
              }
              onDelete={removeFiltering}
            />
          </Stack>
        ) : null}
        {/* {partnerList.length > 0 &&
         
          partnerList.map((partner: IStorePartner) =>
            partner.OrderTypeName === "pickme" ? (
              <div
                style={{
                  margin: "0.5rem",
                }}
              >
                <Button variant="contained" onClick={getPickMeOrders}>
                  Get PickMe Orders
                </Button>
              </div>
            ) : null
          )} */}

        <div className={styles.nav_header}>
          <div className={styles.nav_items}>
            {navItems.length > 0 &&
              navItems.map(
                (orderPosStatus: IOrderStatus) =>
                  orderPosStatus.IsTabOrderStatus && (
                    <div
                      key={orderPosStatus.POSStatusKey}
                      className={cx(
                        styles.nav_item,
                        selectedNavItem.POSStatusKey ===
                          orderPosStatus.POSStatusKey &&
                          styles.nav_item_selected
                      )}
                      onClick={() => setSelectedNavItem(orderPosStatus)}
                    >
                      {orderPosStatus && (
                        <OrderCount
                          POSStatusKey={orderPosStatus.POSStatusKey}
                          filteredDateValue={filteredDateValue}
                        />
                      )}

                      {orderPosStatus.POSStatusName}
                    </div>
                  )
              )}
          </div>
          <div className={styles.filter_menu}>
            <SearchIcon
              onClick={toggleSearchModal}
              className={styles.search_icon}
            />
            <FilterListIcon
              onClick={toggleFilterModal}
              className={styles.filter_icon}
            />
            {/*             <p>
              {isFiltered
                ? moment(filteredDateValue).format("DD-MM-YYYY")
                : null}
            </p> */}
          </div>
        </div>
        <div className={styles.data_table}>
          {selectedItem && (
            <DataTable
              orders={orderList}
              filteredDateValue={filteredDateValue}
              selectedNavItem={selectedNavItem}
              selectedItem={selectedItem}
              selectItem={selectItem}
              posOrderStatus={navItems}
              statusForBtn={statusForBtn}
              updateOrder={updateOrder}
              handleBillPrinting={handleBillPrinting}
            />
          )}
        </div>
      </div>
      {!isTablet && (
        <div className={styles.view_order}>
          {selectedItem && selectedNavItem ? (
            <OrderDetails
              selectedItem={selectedItem}
              updateOrder={updateOrder}
              posOrderStatus={navItems}
              handleBillPrinting={handleBillPrinting}
            />
          ) : (
            <div className={styles.no_order}>
              <h3 className={styles.no_order_text}>
                No selected orders to display
              </h3>
            </div>
          )}
        </div>
      )}

      {/* order details modal */}
      {selectedItem &&
      selectedNavItem &&
      selectedItem.OrderDelivery.OrderStatus.POSStatusCode !== "Rejected" ? (
        <BasicModal isOpen={isOpen} toggle={toggleModal} size="lg">
          <OrderDetails
            selectedItem={selectedItem}
            updateOrder={updateOrder}
            posOrderStatus={navItems}
            handleBillPrinting={handleBillPrinting}
          />
        </BasicModal>
      ) : (
        <BasicModal isOpen={isOpen} toggle={toggleModal} size="lg">
          <div className={styles.no_order}>
            <h3 className={styles.no_order_text}>
              No selected orders to display
            </h3>
          </div>
        </BasicModal>
      )}

      {/* search modal */}
      <BasicModal
        isOpen={isOpenSearch}
        toggle={toggleSearchModal}
        size="md"
        closeIcon={false}
      >
        <SearchBox
          toggle={toggleSearchModal}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          updateOrder={updateOrder}
          posOrderStatus={navItems}
          handleBillPrinting={handleBillPrinting}
        />
      </BasicModal>

      {/* filter modal */}
      <BasicModal
        isOpen={isOpenFilter}
        toggle={toggleFilterModal}
        size="md"
        closeIcon={false}
      >
        <FilterBox
          toggle={toggleFilterModal}
          handleFiltering={handleFiltering}
        />
      </BasicModal>
      {snackBarmodel.openSnackBar && <SnackBar snackBarModel={snackBarmodel} />}
    </div>
  );
};

export default OrdersPage;
/* function useSound(audio: any): [any] {
  throw new Error("Function not implemented.");
} */
